module.exports = __webpack_public_path__ + "static/img/nav10.60985aaf.svg";